import React, { useState, useEffect, useContext } from 'react';
import Layout from '../../components/Layout';
import {
    Container,
    Paper,
    Typography,
    Box,
    Alert,
    CircularProgress,
    Divider,
    Stack
} from '@mui/material';
import { AuthContext } from '../../AuthContext';
import axios from 'axios';
import LogoUpload from '../../components/LogoUpload';

const PartnerLogo = () => {
    const { user } = useContext(AuthContext);
    const [partnerInfo, setPartnerInfo] = useState(null);
    const [loading, setLoading] = useState(true);
    const [message, setMessage] = useState({ type: '', text: '' });

    useEffect(() => {
        fetchPartnerInfo();
    }, []);

    const fetchPartnerInfo = async () => {
        try {
            setLoading(true);
            const response = await axios.get('/api/partners/current-partner-info');
            setPartnerInfo(response.data);
        } catch (error) {
            console.error('Error fetching partner info:', error);
            setMessage({ 
                type: 'error', 
                text: 'Failed to load partner information' 
            });
        } finally {
            setLoading(false);
        }
    };

    const handleLogoChange = async (newLogoUrl) => {
        // Refresh partner info to show new logo
        await fetchPartnerInfo();
        
        // Also refresh the parent component's partner info if we're in the PartnerHome
        if (window.location.pathname === '/partner-admin/') {
            window.location.reload();
        }
    };

    const handleError = (errorMessage) => {
        setMessage({ type: 'error', text: errorMessage });
    };

    const handleSuccess = (successMessage) => {
        setMessage({ type: 'success', text: successMessage });
    };

    const clearMessage = () => {
        setMessage({ type: '', text: '' });
    };

    if (loading) {
        return (
            <Layout title="Partner Logo">
                <Container maxWidth="md" sx={{ py: 4 }}>
                    <Box display="flex" justifyContent="center" alignItems="center" minHeight="300px">
                        <CircularProgress />
                    </Box>
                </Container>
            </Layout>
        );
    }

    return (
        <Layout title="Partner Logo">
            <Container maxWidth="md" sx={{ py: 4 }}>
                <Typography variant="h4" sx={{ mb: 3, fontWeight: 700 }}>
                    Partner Logo Management
                </Typography>

                {message.text && (
                    <Alert 
                        severity={message.type} 
                        onClose={clearMessage}
                        sx={{ mb: 3 }}
                    >
                        {message.text}
                    </Alert>
                )}

                <Stack spacing={3}>
                    <Paper elevation={2} sx={{ p: 3 }}>
                        <LogoUpload
                            currentLogo={partnerInfo?.partnerLogo}
                            onLogoChange={handleLogoChange}
                            onError={handleError}
                            onSuccess={handleSuccess}
                            compact={false}
                            showCurrentLogo={true}
                            allowDelete={true}
                        />
                    </Paper>
                </Stack>
            </Container>
        </Layout>
    );
};

export default PartnerLogo;
